import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import Button from '../../../components/ui/Button';
import CheckboxInput from '../../../components/ui/CheckboxInput';

// Toplu seçim şeridi — AtsApplicationsPage'in BulkBar deseni (sayfa-yerel checkbox
// kolonu + yalnız ≥1 satır seçiliyken çizilen şerit). DataTable'ın kendi seçimi
// yalnız `onRowsDelete`e bağlı olduğu için KULLANILMAZ. Seçim SAYFA kapsamlıdır ve
// bu arayüzde yazılı durur.
const Bar = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px 14px;
  padding: 10px 14px;
  margin-bottom: 12px;
  background: rgba(2, 145, 239, 0.06);
  border: 1px solid rgba(2, 145, 239, 0.18);
  border-radius: 6px;
`;

const Count = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
`;

const ScopeNote = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.dark.little};
`;

const Spacer = styled.span`
  flex: 1;
`;

export const SelectCell = styled.div``;

export default function SelectionBar({ count, onClear, children }) {
  const { t } = useTranslation();
  if (!count) return null;
  return (
    <Bar data-role="ats-selection-bar">
      <Count data-role="ats-selection-count">
        {t('ats.candidatePool.selectedCount', { count })}
      </Count>
      <ScopeNote>{t('ats.candidatePool.pageScopeNote')}</ScopeNote>
      <Spacer />
      <Button type="button" variant="outline" onClick={onClear} data-role="ats-selection-clear">
        {t('ats.candidatePool.clearSelection')}
      </Button>
      {children}
    </Bar>
  );
}

// Sayfa-yerel seçim kolonu. Hücre tıklaması satırın onRowClick'ine YÜKSELMEZ.
export const selectionColumn = ({ data, selectedIds, onToggle, idOf = (r) => r.id }) => ({
  name: 'bulkSelect',
  label: ' ',
  options: {
    filter: false, sort: false, download: false, print: false, viewColumns: false,
    customBodyRender: (_, tableMeta) => {
      const row = data[tableMeta.rowIndex];
      if (!row) return null;
      const id = idOf(row);
      return (
        <SelectCell data-role={`select-${id}`} onClick={(e) => e.stopPropagation()}>
          <CheckboxInput checked={selectedIds.includes(id)} onChange={() => onToggle(id)} />
        </SelectCell>
      );
    },
  },
});
